import * as z from "zod/v4";

export const createViewFolder = {
  name: "createViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
